import { render, staticRenderFns } from "./UploadDocumentModal.vue?vue&type=template&id=dca676ba"
import script from "./UploadDocumentModal.vue?vue&type=script&lang=ts"
export * from "./UploadDocumentModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dca676ba')) {
      api.createRecord('dca676ba', component.options)
    } else {
      api.reload('dca676ba', component.options)
    }
    module.hot.accept("./UploadDocumentModal.vue?vue&type=template&id=dca676ba", function () {
      api.rerender('dca676ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/aws-files-modules/UploadDocumentModal.vue"
export default component.exports